import { ComponentPropsWithoutRef } from 'react';

type LogoVariant =
  | 'primary'
  | 'minor'
  | 'tertiary'
  | 'tertiary-light'
  | 'lavender'
  | 'lightLavender';
const variantColors = {
  primary: '#2B1A3C',
  minor: '#FFF1E3',
  tertiary: '#265B5B',
  'tertiary-light': '#F4FFFE',
  lavender: '#9788C0',
  lightLavender: '#E1D4EB',
};

interface LogoProps extends ComponentPropsWithoutRef<'svg'> {
  variant?: LogoVariant;
}

export const Logo = (props: LogoProps) => (
  <svg
    viewBox="0 0 559 79"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M242.613 53.625c-.002 14.32-12.717 24.626-38.452 24.626-11.108 0-26.853-3.62-36.944-8.479l8.328-22.065c9.488 4.006 22.052 8.328 30.17 8.328 2.708 0 4.55-.78 4.55-2.158 0-1.772-3.451-2.467-9.102-3.607h-.001c-2.778-.56-6.088-1.228-9.782-2.183-14.898-3.843-25.671-11.24-25.671-22.78 0-14.308 12.701-24.623 38.439-24.623 11.108 0 26.858 3.62 36.95 8.479l-8.328 22.065c-9.482-4.006-22.216-8.328-30.327-8.328-2.709 0-4.538.78-4.538 2.158 0 1.846 2.842 2.412 9.07 3.652 2.686.535 6.002 1.195 9.992 2.138 14.215 3.37 25.644 12.234 25.646 22.777Zm0 0v.003-.007.004ZM76.29 59.438c.013 3.39.223 6.773.636 10.137v-.02c.282 2.158 1.311 3.62 2.688 4.223v2.558H53.037c-1.357-.597-2.373-2.053-2.655-4.197-.446-3.37-.721-7.83-.86-11.272-.19-4.046-.8-5.757-2.222-7.101-1.062-1.004-2.374-1.489-4.57-1.489H27.791v24.052H.684V2.56h51.33c14.335 0 26.151 6.446 26.151 21.338 0 8.846-3.082 15.147-10.472 18.813 2.86 1.456 4.944 3.43 6.144 5.757 1.62 3.16 2.394 6.367 2.453 10.97Zm-32.78-26.25c1.6 0 2.806-.425 3.606-1.245.78-.853 1.187-2.105 1.187-3.784 0-1.678-.387-2.944-1.187-3.764-.8-.82-2.006-1.245-3.606-1.245H27.785v10.039H43.51Zm72.722 15.82h35.855V29.906h-35.855v-6.013h42.472V2.575H89.13l-.832 73.77h69.73l.833-21.33h-42.629v-6.007Zm399.196 0h35.869V29.906h-35.856v-6.013h42.472V2.575H488.32v73.77h69.731v-21.33h-42.63v-6.007h.007ZM482.996 2.575l-29.075 73.77h-25.265l-29.062-73.77h26.275l15.423 39.134 15.416-39.134h26.288Zm-141.281 0h27.108v52.36h41.593v21.41h-68.701V2.575ZM291.079.685c12.426 0 23.082 3.39 30.754 9.783h.013c8.118 6.773 12.406 16.262 12.406 28.4 0 12.137-4.196 22.268-12.124 29.284-7.711 6.826-18.734 10.099-31.508 10.099-12.774 0-23.508-3.351-31.101-10.328-7.587-6.977-11.6-16.76-11.6-28.485 0-11.725 4.439-21.646 12.833-28.675C268.509 4.258 278.653.684 291.079.684Zm-4.492 23.245a9.042 9.042 0 0 0-3.344 3.102v.013c-1.954 2.878-2.957 7.062-2.957 12.308 0 5.245 1.036 9.554 2.996 12.452a9.3 9.3 0 0 0 3.41 3.148 9.284 9.284 0 0 0 4.499 1.101 8.98 8.98 0 0 0 4.452-1.134 9.045 9.045 0 0 0 3.318-3.187c1.928-2.898 2.951-7.22 2.951-12.38 0-5.16-1.056-9.417-3.056-12.302a9.277 9.277 0 0 0-3.39-3.101 9.169 9.169 0 0 0-4.452-1.089 9 9 0 0 0-4.427 1.069Z"
      fill={variantColors[props.variant ? props.variant : 'primary']}
    />
  </svg>
);
